import {Component, OnInit, ViewChild} from '@angular/core';
import {PromotionsSModel} from '../../../../../components/parentchild/promotionsS/promotionsS.model';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService} from 'primeng/primeng';
import {LocalStorageService} from 'ng2-webstorage';
import {NgForm} from '@angular/forms';
import {ApprovalClassModel} from '../../../../../components/googleClassroom/googleClassroom.model';
import {AddStudentRcModel, rciModel} from '../../../../../components/dataAnalytics/dataAnalytics.model';
import {ActivatedRoute, Router} from '@angular/router';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {AppConstants} from '../../../../../app.constants';
import * as html2pdf from "html2pdf.js"


@Component({
  selector: 'app-student-profile',
  templateUrl: './question-bank.component.html',
  styleUrls: ['./question-bank.component.css']
})

export class QuestionBankComponent implements OnInit {

  @ViewChild('form') form : NgForm;
  selectedFile: File;
  selectStyle: string;
  public previwbtn: boolean = true;
  public printbtn: boolean = false;
  approvalClassModel = new ApprovalClassModel();
  addStudentRcModel = new AddStudentRcModel();
  rcimodel = new rciModel()
  // public data1: AddStudentRcModel[];
  public ReportsData: any = [];
  googleUser: any;
  studentList = [];
  courseId: any;
  selectedGrade: any;
  selectedSection: any = [];
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  studentRCData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: any;
  gclList: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  standardId: any = [];
  nameofstd: any = [];
  nameofsec: any = [];
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  nameofsem: any = [];
  nameoftest: any = [];
  loading = "none"
  ChildTestMappingId: string;
  students: any = [];
  SemesterData: any = [];
  YearData: any = [];
  TestData: any = [];
  SchoolDetailsaddress : any =[];
  NumberOfStudents: any = [];
  studentId: any = [];
  testId: any = [];
  sectionId: any = []
  guru: any = [];
  payload: any = [];
  public isEditable : Boolean = true;
  Marks: any = [];
  MaxMarks: any = [];
  today = new Date();
  Averages: any;
  schoolName :any;

  subjectsList: any = [];

  QuestionData: any;
  QuestionList: any = [];
  papersToBeDelete: any = [];

  selectedSubject: any;
  selectedYear: any;
  selectedSemester: any;
  selectedTest: any;
  selectedPaperType: any;


  paperDetails: any;

  public isSuccessful: number = 0;
  public successOrErrorMsg: string = "";

  selectAllChecked: boolean = false; // Tracks the state of the "Select All" checkbox


  public grade: any = [];
  public selectedgrade:  any;
  public selectedsection:  any;

  public CurrentChild: any;
  public schoolLogo1 :string;
  public imgUrl1: string;
  public adminUserFlag: boolean;
  public schoolUserFlag: boolean;
  public mappedData: any;
  public attachment;
  public Address: any;
  public City : any;
  public Pincode : any;
  public PrimaryPhonenumber : any;
  public WebsiteLink : any;
  public Email : any;
  public Logo : any;
  public RegNo :any;
  public searchHistory :any;
  public userId :string;
  public childMapId : any = [];
  public TeacherNames : any = [];
  public EncodedLogo : any;
  public ShowLevelData: any;
  public selectedlevel: any;

  isLoading: boolean = false;




  constructor(private dataAnalyticsService: DataAnalyticsService,
              private router: Router,
              private route: ActivatedRoute,
              private noticeboardService: NoticeboardService,
              private appConstants: AppConstants,
              private localStorage: LocalStorageService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService) {

    // this.schoolName = this.localStorage.retrieve('schoolname');
    this.schoolLogo1 = this.localStorage.retrieve('Logo');
    this.imgUrl1 = this.appConstants.fileDownloadUrl;
    // this.attachment = this.imgUrl1 + this.Logo;
    this.userId = this.localStorage.retrieve('id');
  }

  ngOnInit() {

    //----------------------------------
    this.adminUserFlag = this.localStorage.retrieve('IsSchoolAdminUser');
    this.schoolUserFlag = this.localStorage.retrieve('Isschooluser');

    const historyString = this.route.snapshot.queryParamMap.get('history');

    if (historyString){
      this.searchHistory = JSON.parse(decodeURIComponent(historyString));
      console.log(this.searchHistory.yearId);
      console.log(this.searchHistory.selectedLevel);
      console.log(this.searchHistory.selectedGrade);
      console.log(this.searchHistory.selectedSection);
      console.log(this.searchHistory.selectedSubject);
      console.log(this.searchHistory.selectedSemester);
      console.log(this.searchHistory.selectedTest);
      console.log(this.searchHistory.selectedPaperType);
    }

    if (this.searchHistory){
      this.selectedPaperType = this.searchHistory.selectedPaperType;
    }else{
      this.selectedPaperType = 0;
    }

    this.getLevelsName();
    this.getYearData();
  }

  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedSection.SectionId).finally(() => { }).subscribe(
      response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        try {
          if (this.searchHistory){
            const searchSubjectId = this.searchHistory.selectedSubject.SubjectId;
            this.selectedSubject = this.subjectsList.find(subject => subject.SubjectId === searchSubjectId);
          }else{
            this.selectedSubject = this.subjectsList[0];
          }
          this.getSemesterData()
        } catch (error) {

        }
      },
      error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
      });
  }


  onSelectedSubject(subject){
    this.papersToBeDelete = [];
    console.log("onSelectedSubject", subject);
    // this.getQuestionsList();
  }


  // manage-user data
  public get_userdetailes() {
    var id = this.localStorage.retrieve('Id');
    this.noticeboardService.getUserdetailbyId(id).subscribe(response => {
      this.userdetailes = response['selectedSbAccessPermission'];
      const isAdmin = this.userdetailes.some(u => u.Rank == 1);

      let result = this.mappedData.filter(m =>
        this.userdetailes.some(u => u.standardid === m.standardId && (u.Rank == 2 || u.Rank == 3)
        ));
      const sectionsResult = this.mappedData.filter(m => (
        this.userdetailes.some(u => !result.some(r => r.standardId === u.standardid) && u.Rank == 4 && m.Sections.some(s => s.SectionId === u.sectionid))
      )).map(m => ({
        ...m,
        Sections: m.Sections.filter(s => this.userdetailes.some(u => u.sectionid === s.SectionId))
      }));
      result = result.concat(sectionsResult);
      this.newSectionArray = result;
      console.log(result, 'result');
    })
  }


  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
          if (this.searchHistory){
            const searchGradeId = this.searchHistory.selectedGrade.standardId;
            this.selectedGrade = this.mappedData.find(grade => grade.standardId === searchGradeId);
            this.getSectionByGrade(this.selectedGrade);

            const searchSectionId = this.searchHistory.selectedSection.SectionId;
            this.selectedSection = this.selectedGrade.Sections.find(section => section.SectionId === searchSectionId);
            this.getSubjects();
          }else{
            this.selectedGrade = mappedData[mappedData.length - 1];
            this.getSectionByGrade(this.selectedGrade);
            this.selectedSection = this.selectedGrade.Sections[0];
            this.getSubjects();
          }
        } catch (error) {
          //window.location.reload();
        }

        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
        } catch (error) {

        }
      },
      error => {
        this.mappedData = [];
        this.sectionList = [];
        this.subjectsList = [];
        this.selectedGrade = null;
        this.selectedSection = null;
        this.selectedSubject = null;
      });
  };


  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (this.adminUserFlag) {
          this.mappedData = mappedData;
        }
        else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }
      },
      error => {
      });
  };


  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.papersToBeDelete = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    this.sectionList.sort((a, b) => {
      if (a.sectionName.toLowerCase() < b.sectionName.toLowerCase()) {
        return -1;
      }
      if (a.sectionName.toLowerCase() > b.sectionName.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    try {
      this.selectedSection = this.sectionList[0];
      this.getSubjects();
    } catch (error) {

    }
  }


  getGclClassesListById(section) {
    this.students = [];
    this.papersToBeDelete = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.nameofstudent = [];
    this.getSubjects();
  }



  getYearList(year) {
    this.papersToBeDelete = [];
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
  }

  private getSemesterData() {
    this.dataAnalyticsService.getSemester(this.yearId)._finally(() => { }).subscribe(
      response => {
        this.SemesterData = response['semestersList'];
        console.log("Semesters",this.SemesterData )
        // console.log("academicYearId", academicYearId )
        try {
          if (this.searchHistory){
            const searchSemesterId = this.searchHistory.selectedSemester.SemesterId;
            this.selectedSemester = this.SemesterData.find(sem => sem.SemesterId === searchSemesterId);
            this.getTestData(this.selectedSemester.SemesterId);
          }else{
            this.selectedSemester = this.SemesterData[0];
            // this.selectedSemester = 'All';
            this.getTestData(this.selectedSemester.SemesterId);
          }
        } catch (error) {

        }
      }
    )
  }




  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      response => {
        this.YearData = response['yearList'];
        // console.log(this.YearData);
        this.yearId = this.YearData[0].YearId;
        console.log(this.yearId);
        try {
          if (this.searchHistory){
            const searchYearId = this.searchHistory.yearId.YearId;
            this.selectedYear = this.YearData.find(year => year.YearId === searchYearId);
          }else{
            this.selectedYear = this.YearData[0];
          }
        } catch (error) {

        }

        // console.log(response )
      }
    )
  }


  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          if (this.searchHistory){
            this.selectedlevel = this.searchHistory.selectedLevel;
            this.getLevelClassSection(this.selectedlevel);
          }else{
            this.selectedlevel =  this.ShowLevelData[0].Id;
            //this.getClassSection(this.selectedlevel["Id"]);
            this.getLevelClassSection(this.selectedlevel);
          }
        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
      }, (error) => {

      });
  }

  getLevelsListById(){
    this.papersToBeDelete = [];
    console.log("fffff", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }

  private GetGrade(){
    this.dataAnalyticsService.getGradeLevel(this.selectedlevel).finally(() => { }).subscribe(
      response => {
        this.grade = response;
        try {
          this.selectedgrade =  this.grade[0].standardId;

        } catch (error) {

        }
        console.log('grade',this.grade)
      },
      error => {
        this.grade = [];
        console.error(error);
        console.log('grade',this.grade)
      });
  };

  changegrade() {
    console.log(this.selectedgrade)

  };
  changesection(){
    console.log(this.selectedsection)
  }



  getSemesterListById(sem){
    console.log(sem)
    this.TestData = [];
    this.papersToBeDelete = [];
    this.studentRCData = [];
    this.nameofsem= sem.SemesterName;
    this.getTestData(sem.SemesterId);
  }

  private getTestData(SemesterId) {
    this.dataAnalyticsService.getTest(SemesterId)._finally(() => { }).subscribe(
      response => {
        this.TestData = response['testsList'];
        try {
          if (this.searchHistory){
            const searchTestId = this.searchHistory.selectedTest.TestId;
            this.selectedTest = this.TestData.find(test => test.TestId === searchTestId);
            this.getQuestionsList();
          }else{
            // this.selectedTest = 'All';
            this.selectedTest = this.TestData[0];
          }
          // this.selectedTest = this.TestData[0];

        } catch (error) {
        }
      }
    )
  }

  getTestListById(test){
    console.log(test)
    this.QuestionList = [];
    this.papersToBeDelete = [];
    this.studentRCData = [];
    this.testId = test.TestId;
    this.nameoftest = test.TestName;
  }




  getQuestionsList() {
    this.QuestionList = [];
    this.dataAnalyticsService.getQuestionPapers(
      this.yearId,
      this.selectedGrade.standardId,
      this.selectedSubject.SubjectId,
      this.selectedSemester.SemesterId,
      this.selectedTest.TestId, this.selectedPaperType).finally(() => { }).subscribe(
      response => {
        this.QuestionList = response['Value'];
        console.log(this.QuestionList);

      },
      error => {
        console.error(error);
      });

  }


  viewPaper(paper) {
    this.isLoading = true; // Start loading
    this.dataAnalyticsService.getQuestionPDF(paper.Id).finally(() => {this.isLoading = false;}).subscribe(
      response => {
        console.log(response);
        this.paperDetails = response['Value'];
        const searchHistory = {
          yearId: this.selectedYear,
          selectedLevel: this.selectedlevel,
          selectedGrade: this.selectedGrade,
          selectedSection: this.selectedSection,
          selectedSubject: this.selectedSubject,
          selectedSemester: this.selectedSemester,
          selectedTest: this.selectedTest,
          selectedPaperType: this.selectedPaperType,
        }
        let base64PDF = this.paperDetails[0].PDFContent;
        paper['PDFContent'] = base64PDF;
        const serializedObj = encodeURIComponent(JSON.stringify(paper));
        const serializedHistory = encodeURIComponent(JSON.stringify(searchHistory));

        this.router.navigate(['parent/view-paper'], { queryParams: { paper: serializedObj, history: serializedHistory } });
        this.isLoading = false; // Start loading
      },
      error => {
        console.error(error)
        this.isLoading = false; // Start loading
        this.messageService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: "This paper can't be viewed",
        });
      });
  }

  deletePaper(question: any) {
    this.papersToBeDelete.push(question);
    const payload = {
      Papers : this.papersToBeDelete
    }
    this.dataAnalyticsService.deletePaper(payload).subscribe(
      response => {
        console.log('Delete successful', response);
        this.messageService.add({
          severity: "success",
          summary: "Quanta Intelligence",
          detail: "Successfully delete paper",
        });
        this.getQuestionsList();
        this.papersToBeDelete = [];
      },
      error => {
        console.error('Delete failed', error);
        this.messageService.add({
          severity: "error",
          summary: "Quanta Intelligence",
          detail: "Delete paper failed",
        });
      }
    );
  }


  toggleCheckbox(question: any) {
    if (question.selected) {
      // Add to array if checked
      this.papersToBeDelete.push(question);
    } else {
      // Remove from array if unchecked
      const index = this.papersToBeDelete.indexOf(question);
      if (index !== -1) {
        this.papersToBeDelete.splice(index, 1);
      }
    }
    console.log('Papers to be deleted:', this.papersToBeDelete);
  }


  deleteSelectedPapers() {
    const payload = {
      Papers : this.papersToBeDelete
    }
    this.dataAnalyticsService.deletePaper(payload).subscribe(
      response => {
        console.log('Delete successful', response);
        this.messageService.add({
          severity: "success",
          summary: "Quanta Intelligence",
          detail: "Successfully delete papers",
        });
        this.getQuestionsList();
        this.papersToBeDelete = [];
      },
      error => {
        console.error('Delete failed', error);
        this.messageService.add({
          severity: "error",
          summary: "Quanta Intelligence",
          detail: "Delete paper failed",
        });
      }
    );
  }

  confirm(question: any) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this paper?',
      accept: () => {
        this.deletePaper(question);
      }
    });
  }

  confirmAll() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete these selected papers?',
      accept: () => {
        this.deleteSelectedPapers();
      }
    });
  }

  findPapers() {
    this.getQuestionsList();
  }


  toggleSelectAll() {
    this.papersToBeDelete = []; // Clear array initially
    this.QuestionList.forEach((question: any) => {
      question.selected = this.selectAllChecked; // Check or uncheck all checkboxes
      if (this.selectAllChecked) {
        this.papersToBeDelete.push(question);
      }
    });

    console.log('Papers to be deleted:', this.papersToBeDelete);
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/quonta-intelligence/question-bank/question-bank.component.ts